import LinkToDocusaurus from '../LinkToDocusaurus'
import { monitorConfig } from '../../docs-routes'

const LinkToMonitorConfigDoc = () =>
  <LinkToDocusaurus path={monitorConfig}>
    Learn more about Monitor Config
  </LinkToDocusaurus>

export default LinkToMonitorConfigDoc
